import React from 'react';
import '../template-file-css/document-file-template.css';


export const C3_Dla = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='C3_Dla' className='file-pdf-document'>

            <div className='file-template'>


            <table>
                    <tr>
                        <td className='w-750'><h2>DLA-20 Self Report</h2></td>
                    </tr>
                    <tr>
                        <td className='w-750'><h3>During the last 30 days... did your symptoms interrupt any of the follwing everyday activities?</h3></td>
                    </tr>
                    <tr>
                        <td className='w-750'><h4>Please use sclae below to score each daily living activity</h4></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>1. No, not at all </b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>2. Rarely </b></td>
                    </tr><tr>
                        <td className='w-750'><b>3. Sometimes </b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>4. Usually </b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>5. Yes, always </b></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Physical Health and Mental Wellness </span><span className='small'>During the last 30 days...</span></td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>1.</b> I managed my mental health symptoms such as anxiety, racing or disturbing thoughts, depression, memory lapses or stressful repetitive behaviors. <br />Other symptoms/comment: &nbsp;
                            <input type='text' id='txtPhysicalHealthMentalWellnessOther_1' name='txtPhysicalHealthMentalWellnessOther_1' className='add-only' /></td>
                        <td className='w-150'>  <input type='text' id='txtPhysicalHealthMentalWellness_1' name='txtPhysicalHealthMentalWellness_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>2.</b> I managed my moods such as anger, sadness or happiness. </td>
                        <td className='w-150'>  <input type='text' id='txtPhysicalHealthMentalWellness_2' name='txtPhysicalHealthMentalWellness_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>3.</b> I managed my physical health such as problems with pain, high blood pressure, weight or diet restrictions. <br />Other symptoms/comment: &nbsp;
                            <input type='text' id='txtPhysicalHealthMentalWellnessOther_2' name='txtPhysicalHealthMentalWellnessOther_2' className='add-only' /></td>
                        <td className='w-150'>  <input type='text' id='txtPhysicalHealthMentalWellness_3' name='txtPhysicalHealthMentalWellness_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>4. I took all my medications as prescribed.
                            <br /><input type='checkbox' id='cbPhysicalHealthMentalWellnessNa_4' name='cbPhysicalHealthMentalWellnessNa_4' className='add-only' /> N/ A (not on medication) </td>
                        <td className='w-150'>  <input type='text' id='txtPhysicalHealthMentalWellness_4' name='txtPhysicalHealthMentalWellness_4' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Stable Housing </span><span className='small'>During the last 30 days... </span></td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>1.</b> I lived in the same place.</td>
                        <td className='w-150'>  <input type='text' id='txtStableHousing_1' name='txtStableHousing_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>2.</b> I managed to keep up with my household duties such as cleaning. </td>
                        <td className='w-150'>  <input type='text' id='txtStableHousing_2' name='txtStableHousing_2' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Communication</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>1.</b> I listened to others and understood what they were saying.</td>
                        <td className='w-150'>  <input type='text' id='txtCommunication_1' name='txtCommunication_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>2.</b> I was able to focus, express my needs and wants In a positive manner.</td>
                        <td className='w-150'>  <input type='text' id='txtCommunication_2' name='txtCommunication_2' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Safety</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'> <b>1.</b> I have been free from thoughts of harming myself.</td>
                        <td className='w-150'>  <input type='text' id='txtSafety_1' name='txtSafety_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I have been free from thoughts to harm others.</td>
                        <td className='w-150'>  <input type='text' id='txtSafety_2' name='txtSafety_2' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-600'> <b>3.</b> I made safe decisions at home and while out in the community.</td>
                        <td className='w-150'>  <input type='text' id='txtSafety_3' name='txtSafety_3' className='add-only' /></td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Time Management</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I slept between 5-9 hours most nights.</td>
                        <td className='w-150'>  <input type='text' id='txtTimeManagement_1' name='txtTimeManagement_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I felt rested most days when I woke up.</td>
                        <td className='w-150'>  <input type='text' id='txtTimeManagement_2' name='txtTimeManagement_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>3.</b> I followed a regular routine most days.</td>
                        <td className='w-150'>  <input type='text' id='txtTimeManagement_3' name='txtTimeManagement_3' className='add-only' /></td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Money Management </span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I had a monthly source of income.</td>
                        <td className='w-150'><input type='text' id='txtMoneyManagement_1' name='txtMoneyManagement_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I independently managed my money.</td>
                        <td className='w-150'>  <input type='text' id='txtMoneyManagement_2' name='txtMoneyManagement_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>3.</b> I paid my bills and expenses on my own.</td>
                        <td className='w-150'>  <input type='text' id='txtMoneyManagement_3' name='txtMoneyManagement_3' className='add-only' /></td>
                    </tr>


                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>Nutrition </span><span className='small'>During the last 30 days...</span></td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I ate 2 nutritious meals most days.</td>
                        <td className='w-150'>  <input type='text' id='txtNutrition_1' name='txtNutrition_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I limited my caffeine and sugar intake.</td>
                        <td className='w-150'>  <input type='text' id='txtNutrition_2' name='txtNutrition_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>3.</b> I prepared most of my meals.</td>
                        <td className='w-150'>  <input type='text' id='txtNutrition_3' name='txtNutrition_3' className='add-only' /></td>
                    </tr>

                </table>

                <table>

                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Problem Solving </span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I solved day to day problems.</td>
                        <td className='w-150'>  <input type='text' id='txtProblemSolving_1' name='txtProblemSolving_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I managed stressful situations. </td>
                        <td className='w-150'>  <input type='text' id='txtProblemSolving_2' name='txtProblemSolving_2' className='add-only' /></td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Relationships with Family/Significant Others.</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I felt supported by my family or significant other.  </td>
                        <td className='w-150'><input type='text' id='txtRelationshipsFamilySignificantOthers_1' name='txtRelationshipsFamilySignificantOthers_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I was satisfied with my relationships with family/significant other.</td>
                        <td className='w-150'><input type='text' id='txtRelationshipsFamilySignificantOthers_2' name='txtRelationshipsFamilySignificantOthers_2' className='add-only' /></td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Alcohol & Drugs.</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I avoided drinking more than 2 beers or 2 drinks of alcohol daily.</td>
                        <td className='w-150'>  <input type='text' id='txtAlcoholDrugs_1' name='txtAlcoholDrugs_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I avoided cigarettes, vaplng and tobacco.</td>
                        <td className='w-150'>  <input type='text' id='txtAlcoholDrugs_2' name='txtAlcoholDrugs_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>3.</b> I avoided all drugs such as marijuana, opiates and heroin.</td>
                        <td className='w-150'>  <input type='text' id='txtAlcoholDrugs_3' name='txtAlcoholDrugs_3' className='add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Leisure & Physical Activities.</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I enjoyed time with others in my community, doing a healthy activity.</td>
                        <td className='w-150'><input type='text' id='txtLeisurePhysicalActivities_1' name='txtLeisurePhysicalActivities_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I enjoyed personal hobbies such as exercising, reading, writing, painting or other activities.</td>
                        <td className='w-150'>  <input type='text' id='txtLeisurePhysicalActivities_2' name='txtLeisurePhysicalActivities_2' className='add-only' /></td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Community Resources. </span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I used community resources that I needed such as churches, my doctor's office, mental health clinic or the grocery store.  </td>
                        <td className='w-150'><input type='text' id='txtCommunityResources_1' name='txtCommunityResources_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I used sources of transportation such as a car, bus or a family/friend to help me get around In the community.  </td>
                        <td className='w-150'>  <input type='text' id='txtCommunityResources_2' name='txtCommunityResources_2' className='add-only' /></td>
                    </tr>

                </table>

                <table>

                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Friendships with Support Systems  </span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I enjoyed time with a friend, neighbor or co-worker.   </td>
                        <td className='w-150'>  <input type='text' id='txtFriendshipsSupportSystems_1' name='txtFriendshipsSupportSystems_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> Friends, neighbors or co-workers were kind and supportive of me.  </td>
                        <td className='w-150'>  <input type='text' id='txtFriendshipsSupportSystems_2' name='txtFriendshipsSupportSystems_2' className='add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'> Sexual Health </span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I am satisfied with my current relationship status such as single or In relationship with a partner. </td>
                        <td className='w-150'>  <input type='text' id='txtSexualHealth_1 ' name='txtSexualHealth_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I am satisfied that I am choosing safe sexual practices.  </td>
                        <td className='w-150'>  <input type='text' id='txtSexualHealth_2' name='txtSexualHealth_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>3.</b> I have questions and want to talk to my provider about sexual health concerns.</td>
                        <td className='w-150'>
                            <input type='radio' id='rbSexualHealth_3Yes' name='rbSexualHealth_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSexualHealth_3No' name='rbSexualHealth_3' className='add-only' value='No' /> No
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Productivity </span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I am satisfied with my role of working at a job, homemaking, volunteering or attending school.   </td>
                        <td className='w-150'><input type='text' id='txtProductivity_1' name='txtProductivity_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I feel productive while working at a job, homemaking, volunteering or at school.  </td>
                        <td className='w-150'>  <input type='text' id='txtProductivity_2' name='txtProductivity_2' className='add-only' /></td>
                    </tr>

                </table>

                <table>

                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'> Coping</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I recognized my triggers such as symptoms or events that may lead to relapse.    </td>
                        <td className='w-150'>  <input type='text' id='txtCoping_1' name='txtCoping_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I used coping skills when I noticed symptoms such as being nervous, Irritated, angry, sad or depressed.   </td>
                        <td className='w-150'>  <input type='text' id='txtCoping_2' name='txtCoping_2' className='add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'> Community Norms</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I enjoyed everyday freedoms in my community without conflict.</td>
                        <td className='w-150'>  <input type='text' id='txtCommunityNorms_1' name='txtCommunityNorms_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I abided by all laws and my Interactions with law enforcement or courts were positive.</td>
                        <td className='w-150'>  <input type='text' id='txtCommunityNorms_2' name='txtCommunityNorms_2' className='add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'> Oral & Personal Hygiene</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> I independently managed my personal hygiene such as baths and showers. </td>
                        <td className='w-150'>  <input type='text' id='txtOralPersonalHygiene_1' name='txtOralPersonalHygiene_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I brushed my teeth each day, with no pain or discomfort. </td>
                        <td className='w-150'>  <input type='text' id='txtOralPersonalHygiene_2' name='txtOralPersonalHygiene_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>3.</b> I was able to eat, chew, drink hot or cold liquids without pain or discomfort. </td>
                        <td className='w-150'><input type='text' id='txtOralPersonalHygiene_3' name='txtOralPersonalHyginene_3' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>Grooming</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> My overall appearance was neat such as hair brushed, hands and nails clean.  </td>
                        <td className='w-150'>  <input type='text' id='txtGrooming_1' name='txtGrooming_1' className='add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'> Dress</span>
                            <span className='small'>During the last 30 days...</span>
                        </td>
                        <td className='w-150'><span className='eleHeader'>Score</span></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>1.</b> My clothes are generally comfortable and clean. </td>
                        <td className='w-150'>  <input type='text' id='txtDress_1' name='txtDress_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-600'> <b>2.</b> I am satisfied that my clothing is In good repair. </td>
                        <td className='w-150'>  <input type='text' id='txtDress_2' name='txtDress_2' className='add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-400'></td>
                        <td className='w-200'><h3>Overall Score : </h3></td>
                        <td className='w-150'><input type='text' id='txtOverallScore' name='txtOverallScore' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







